import { Card, CardContent, Typography, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  color?: string;
}

export default function StatCard({
  title,
  value,
  subtitle,
  icon,
}: StatCardProps) {
  return (
    <Card sx={{ borderRadius: 2, height: "100%" }}>
      <CardContent
        sx={{
          p: { xs: 1.5, sm: 2 },
          "&:last-child": { pb: { xs: 1.5, sm: 2 } },
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: 9, sm: 10 },
              textTransform: "uppercase",
              letterSpacing: 0.5,
              color: "primary.main",
              fontWeight: 600,
              lineHeight: 1.4,
            }}
          >
            {title}
          </Typography>
          {icon && (
            <Box
              sx={{
                p: 0.75,
                borderRadius: 1.5,
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
                color: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                ml: 1,
                "& .MuiSvgIcon-root": { fontSize: { xs: 18, sm: 20 } },
              }}
            >
              {icon}
            </Box>
          )}
        </Box>
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.4rem" },
            lineHeight: 1.2,
            wordBreak: "break-word",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {value}
        </Typography>
        {subtitle && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 0.5,
              fontSize: { xs: 11, sm: 12 },
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
